import { render, staticRenderFns } from "./View3.vue?vue&type=template&id=5241bfa2&scoped=true&"
import script from "./View3.vue?vue&type=script&lang=js&"
export * from "./View3.vue?vue&type=script&lang=js&"
import style0 from "./View3.vue?vue&type=style&index=0&id=5241bfa2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5241bfa2",
  null
  
)

export default component.exports